import { render, staticRenderFns } from "./StandardAccountList.vue?vue&type=template&id=0295f938&scoped=true&lang=pug"
import script from "./StandardAccountList.vue?vue&type=script&lang=ts"
export * from "./StandardAccountList.vue?vue&type=script&lang=ts"
import style0 from "./StandardAccountList.vue?vue&type=style&index=0&id=0295f938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295f938",
  null
  
)

export default component.exports